import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './themes/globalStyles';
import { lightTheme, darkTheme } from './themes/Themes';
import { useDarkMode } from './themes/useDarkMode';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Main from './layouts/Main';

import { Projects } from './layouts/Projects';

function App() {
  const [theme, themeToggler, mountedComponent] = useDarkMode();
  const themeMode = theme === 'light' ? lightTheme : darkTheme;

  if (!mountedComponent) return <div />;
  return (
    <ThemeProvider theme={themeMode}>
      <>
        <GlobalStyles />
        <div className='App'>
          <Router>
            <Switch>
              <Route path='/projects'>
                <Projects theme={theme} toggleTheme={themeToggler} />
              </Route>
              <Route path='/'>
                <Main theme={theme} toggleTheme={themeToggler} />
              </Route>
            </Switch>
          </Router>
        </div>
      </>
    </ThemeProvider>
  );
}

export default App;
